var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { cols: 12 } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title")))]),
                  _c(
                    "w-card-content",
                    [
                      _c("p", { staticClass: "description" }, [
                        _vm._v(_vm._s(_vm.$ct("description"))),
                      ]),
                      _vm._l(_vm.groups, function (group) {
                        return _c(
                          "div",
                          { key: group.key, staticClass: "group-section" },
                          [
                            _c("h3", { staticClass: "group-title" }, [
                              _vm._v(_vm._s(group.label)),
                            ]),
                            _vm.getLinks(group.key).length === 0
                              ? _c("div", { staticClass: "empty-group" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("no-links")) + " "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._l(
                              _vm.getLinks(group.key),
                              function (link, index) {
                                return _c(
                                  "div",
                                  {
                                    key: link.uid,
                                    staticClass: "link-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editLink(group.key, index)
                                      },
                                    },
                                  },
                                  [
                                    _c("app-icon", {
                                      staticClass: "link-icon",
                                      attrs: { icon: link.Icon },
                                    }),
                                    _c("span", { staticClass: "link-name" }, [
                                      _vm._v(_vm._s(link.Name)),
                                    ]),
                                  ],
                                  1
                                )
                              }
                            ),
                            _c(
                              "w-link",
                              {
                                staticClass: "add-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.addLink(group.key)
                                  },
                                },
                              },
                              [
                                _c("w-fa", { attrs: { icon: "plus" } }),
                                _vm._v(" " + _vm._s(_vm.$ct("add-link")) + " "),
                              ],
                              1
                            ),
                          ],
                          2
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.modalOpen,
            callback: function ($$v) {
              _vm.modalOpen = $$v
            },
            expression: "modalOpen",
          },
        },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c("w-card-title", [
                _vm._v(
                  _vm._s(
                    _vm.modalIsNew ? _vm.$ct("add-link") : _vm.$ct("edit-link")
                  )
                ),
              ]),
              _c(
                "w-card-content",
                { staticClass: "modal-form" },
                [
                  _c(
                    "div",
                    { staticClass: "icon-picker" },
                    [
                      _c("app-icon", {
                        staticClass: "icon-preview",
                        attrs: { icon: _vm.editingLink.Icon },
                      }),
                      _c("w-input-autocomplete", {
                        attrs: {
                          value: _vm.editingLink.Icon,
                          items: _vm.filteredIcons,
                          label: _vm.$ct("icon"),
                          "input-delay": 150,
                          fancy: "",
                        },
                        on: {
                          input: _vm.onIconSearch,
                          "item-click": _vm.selectIcon,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (p) {
                              return [
                                _c("app-icon", {
                                  staticClass: "icon-option-icon",
                                  attrs: { icon: p.item },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "icon-option-text" },
                                  [_vm._v(_vm._s(p.item))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("w-input", {
                    attrs: { label: _vm.$ct("button-text"), fancy: "" },
                    model: {
                      value: _vm.editingLink.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.editingLink, "Name", $$v)
                      },
                      expression: "editingLink.Name",
                    },
                  }),
                  _c("w-input", {
                    attrs: { label: _vm.$ct("page-title"), fancy: "" },
                    model: {
                      value: _vm.editingLink.Title,
                      callback: function ($$v) {
                        _vm.$set(_vm.editingLink, "Title", $$v)
                      },
                      expression: "editingLink.Title",
                    },
                  }),
                  _c("w-input", {
                    attrs: { label: _vm.$ct("url"), fancy: "" },
                    model: {
                      value: _vm.editingLink.Url,
                      callback: function ($$v) {
                        _vm.$set(_vm.editingLink, "Url", $$v)
                      },
                      expression: "editingLink.Url",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { fancy: "", label: _vm.$ct("dev-only") },
                    model: {
                      value: _vm.editingLink.DevOnly,
                      callback: function ($$v) {
                        _vm.$set(_vm.editingLink, "DevOnly", $$v)
                      },
                      expression: "editingLink.DevOnly",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  !_vm.modalIsNew
                    ? _c(
                        "w-button",
                        {
                          staticClass: "cancel",
                          attrs: { icon: "trash", disabled: _vm.saving },
                          on: { click: _vm.removeLink },
                        },
                        [_vm._v(_vm._s(_vm.$ct("delete")))]
                      )
                    : _vm._e(),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel mr",
                      attrs: { icon: "ban", disabled: _vm.saving },
                      on: { click: _vm.cancelModal },
                    },
                    [_vm._v(_vm._s(_vm.$ct("cancel")))]
                  ),
                  _c(
                    "w-button",
                    {
                      attrs: { icon: "check", loading: _vm.saving },
                      on: { click: _vm.confirmModal },
                    },
                    [_vm._v(_vm._s(_vm.$ct("save")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }